module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "pythagoras.458b2b18.png";